import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClarityModule } from '@clr/angular';
import { FleetEmbedComponent } from './fleet-embed';
import { HybridInterconnectModule } from '../hybrid-interconnect/hybrid-interconnect.module';
import { AuthTokenInterceptor } from 'app/interceptors/auth-token-interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
@NgModule({
    declarations: [
        FleetEmbedComponent
    ],
    imports: [
        BrowserModule,
        FormsModule,
        TranslateModule,
        RouterModule,
        HttpClientModule,
        ClarityModule.forRoot(),
        HybridInterconnectModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthTokenInterceptor,
            multi: true
        }
    ],
    exports: [
        FleetEmbedComponent
    ]
})

export class FleetModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/fleet/fleet.module.ts